import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './categories.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import Category from '../../admin-components/category/Category'

function Categories() {
    const [cats, setCats] = useState([]);

    const api_uri = "https://mentorxfa.herokuapp.com/api/categories";

    useEffect(() => {
        const fetchCats = async() => {
            const res = await axios.get(api_uri);
            setCats(res.data);           
        }
        fetchCats() 
        return () => {          
          };
    }, []);

    return (
        <>
        <AdminNavbar/>
        <div className="categories">
        <Link to="/admin/category/create"><button className="new-cat-btn">New Category <i className="fas fa-plus-circle"></i></button></Link>
        <div className="categories-wrap">
            {
                cats.map((c) =>(
                    <Link key={c._id} to={`/admin/categories/${c._id}`}>
                        <Category key={c._id} cat={c} />
                    </Link>
                ))
        }           
        </div>
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default Categories
